import Activities from "./activities.svg";
import AddQuestion from "./add-question.svg";
import Add from "./add.svg";
import Add2 from "./add2.svg";
import Addfile from "./addfile.svg";
import Air from "./air.svg";
import Appearance from "./appearance.svg";
import Arrow from "./arrow.svg";
import Arrows from "./arrows.svg";
import BackIcon from "./back-icon.svg";
import Bar from "./bar.svg";
import Bin from "./bin.svg";
import BlockPin from "./blockpin.svg";
import BloodPressure from "./bloodpressure.svg";
import Body from "./body.svg";
import BodySingle from "./bodysingal.svg";
import Breakfast from "./breakfast.svg";
import Calender from "./calendar.svg";
import Care from "./care.svg";
import Carer from "./carer.svg";
import Cartoon from "./cartoon.svg";
import Cartoon1 from "./cartoon1.svg";
import Check from "./check.svg";
import Clinical from "./clinical.svg";
import Clock from "./clock.svg";
import Communication from "./communication.svg";
import Complete from "./complete.svg";
import Continence from "./continence.svg";
import CreateUser from "./createUser.svg";
import Cross from "./cross.svg";
import Csv from "./csv.svg";
import DailyNote from "./dailynotes.svg";
import Date from "./date.svg";
import DateCheck from "./datecheck.svg";
import Delete from "./delete.svg";
import DeleteAlert from "./deleteAlert.svg";
import Desktop from "./desktop.svg";
import Dinner from "./dinner.svg";
import DiscountMedication from "./discountMedication.svg";
import Doc from "./doc.svg";
import Document from "./document.svg";
import DotsHorizontal from "./dots-horizontal.svg";
import Dots from "./dots.svg";
import DownArrow from "./downArrow.svg";
import Dressed from "./dressed.svg";
import Drink from "./drink.svg";
import Dropdown from "./dropdown.svg";
import Edit from "./edit.svg";
import Edits from "./edits.svg";
import EditUser from "./editUser.svg";
import Environment from "./environment.svg";
import Eye from "./eye.svg";
import EyeOpen from "./eyeOpen.svg";
import Family from "./family.svg";
import File from "./file.svg";
import FoodDrink from "./food-drink.svg";
import Food from "./food.svg";
import Friday from "./friday.svg";
import Gallery from "./gallery.svg";
import Getting from "./getting.svg";
import Glucose from "./glucose.svg";
import Group from "./group.svg";
import Handover from "./handover.svg";
import HealthVisit from "./health-visit.svg";
import Health from "./health.svg";
import Heart from "./heart.svg";
import Incident from "./Incident.svg";
import Info from "./info.svg";
import LeftArrow from "./leftarrow.svg";
import LeftThigh from "./leftThigh.svg";
import Line from "./line.svg";
import Lines from "./lines.svg";
import Location from "./location.svg";
import Login from "./login.svg";
import Logo from "./logo.svg";
import Logout from "./logout.svg";
import Lunch from "./lunch.svg";
import Map from "./map.svg";
import Medication from "./medication.svg";
import MedicationNote from "./Medicationnote.svg";
import Medications from "./medications.svg";
import Mobility from "./mobility.svg";
import Monday from "./monday.svg";
import Mood from "./mood.svg";
import MrChart from "./Mrchart.svg";
import Msg from "./Msg.svg";
import MultiUser from "./multiuser.svg";
import Must from "./must.svg";
import NoDoc from "./no-doc.svg";
import Notes from "./notes.svg";
import Notification from "./notification.svg";
import Oral from "./oral.svg";
import Timer from "./timer.svg";
import Oxygen from "./oxygen.svg";
import Pdf from "./pdf.svg";
import Pending from "./pending.svg";
import People from "./people.svg";
import Personal from "./personal.svg";
import Pet from "./pet.svg";
import Phone from "./phone.svg";
import Pin from "./pin.svg";
import PlusSm from "./plus-sm.svg";
import Plus from "./plus.svg";
import Positioning from "./positioning.svg";
import Pudding from "./pudding.svg";
import Question from "./question.svg";
import RequiredUsers from "./requredusers.svg";
import Respiratory from "./respiratory.svg";
import RightArrow from "./rightArrow.svg";
import RightSolder from "./rightSolder.svg";
import Role from "./role.svg";
import Roster from "./roster.svg";
import Routine from "./routine.svg";
import Saturday from "./saturday.svg";
import Search from "./search.svg";
import Send from "./send.svg";
import Setting from "./setting.svg";
import Shaving from "./shaving.svg";
import Signed from "./signed.svg";
import Sine from "./sine.svg";
import Skin from "./skin.svg";
import Skins from "./skins.svg";
import Play from "./skip.svg";
import Sleep from "./sleep.svg";
import Snack from "./snack.svg";
import Stool from "./stool.svg";
import Stop from "./stop.svg";
import Support from "./support.svg";
import TaskDelet from "./taskdelet.svg";
import TaskEdit from "./taskedit.svg";
import Tea from "./tea.svg";
import Temperature from "./temperature.svg";
import Thigh from "./thigh.svg";
import Toileting from "./toileting.svg";
import TrashDelete from "./trash-delete.svg";
import Trash from "./trash.svg";
import Tuesday from "./tuesday.svg";
import Union from "./Union1.svg";
import Upload from "./upload.svg";
import UploadPdf from "./uploadPdf.svg";
import UserProfile from "./user-profile.svg";
import User from "./user.svg";
import Users from "./users.svg";
import View from "./view.svg";
import Warning from "./warning.svg";
import WaterLow from "./waterlow.svg";
import Wednesday from "./wednesday.svg";
import Weight from "./weight.svg";
import WhiteEye from "./whiteEye.svg";
import Wrong from "./wrong.svg";
import Unread from "./unread.svg";
import Read from "./read.svg";
import Announcement from "./announcement.svg";
import Comment from "./comment.svg";

const SVG = {
  Comment,
  Announcement,
  Unread,
  Read,
  Air,
  Add,
  Arrow,
  Add2,
  Arrows,
  Addfile,
  Activities,
  Appearance,
  AddQuestion,
  Communication,
  Breakfast,
  BloodPressure,
  Bar,
  Bin,
  Medications,
  Stop,
  Body,
  BodySingle,
  BackIcon,
  BlockPin,
  Clinical,
  Cartoon1,
  Csv,
  MrChart,
  MedicationNote,
  Continence,
  DiscountMedication,
  Clock,
  Carer,
  Check,
  Cross,
  CreateUser,
  Calender,
  Cartoon,
  Care,
  Complete,
  DailyNote,
  Doc,
  Dropdown,
  Drink,
  Document,
  DownArrow,
  Delete,
  Date,
  Dinner,
  Desktop,
  Dressed,
  DeleteAlert,
  DotsHorizontal,
  DateCheck,
  Dots,
  Eye,
  Edit,
  Edits,
  Environment,
  EyeOpen,
  EditUser,
  File,
  Food,
  FoodDrink,
  Friday,
  Family,
  Group,
  Getting,
  Glucose,
  Gallery,
  Handover,
  HealthVisit,
  Health,
  Heart,
  Info,
  Incident,
  Logo,
  LeftArrow,
  Lunch,
  LeftThigh,
  Location,
  Login,
  Logout,
  Line,
  Msg,
  Mobility,
  Mood,
  Must,
  Monday,
  MultiUser,
  Medication,
  Map,
  Notification,
  Notes,
  NoDoc,
  Oral,
  Oxygen,
  Timer,
  Pending,
  Plus,
  Pdf,
  Pet,
  Pudding,
  Personal,
  Positioning,
  Pin,
  Phone,
  People,
  PlusSm,
  Question,
  Roster,
  RequiredUsers,
  Role,
  RightArrow,
  Routine,
  RightSolder,
  Respiratory,
  Shaving,
  Skin,
  Skins,
  Search,
  Setting,
  Signed,
  Sleep,
  Snack,
  Stool,
  Support,
  Send,
  Saturday,
  Sine,
  Play,
  Toileting,
  Tea,
  Thigh,
  Temperature,
  Trash,
  TaskEdit,
  TaskDelet,
  Tuesday,
  TrashDelete,
  User,
  Upload,
  UploadPdf,
  Union,
  UserProfile,
  Users,
  View,
  WaterLow,
  Weight,
  Wednesday,
  Wrong,
  Lines,
  WhiteEye,
  Warning,
};

// Turbopack can expose loader output as an ES module namespace while webpack
// exposes the component directly. Normalize both shapes so SVG entries remain
// renderable React components regardless of the active Next.js dev compiler.
for (const key of Object.keys(SVG) as Array<keyof typeof SVG>) {
  const icon = SVG[key] as unknown;
  if (icon && typeof icon === "object" && "default" in icon) {
    (SVG as Record<string, unknown>)[key as string] = (
      icon as { default: unknown }
    ).default;
  }
}
export default SVG;
